import { Button, CircularProgress, Divider, Theme } from '@mui/material';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import { MemoButtonContained } from 'components/general/ButtonContained/ButtonContained';
import useIsMobile from 'hooks/useIsMobile';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

export function SubmitFooter({
  onCancel,
  isPosting,
  onSubmit,
  disableSubmit,
  rightContent,
}: {
  onCancel: () => void;
  isPosting: boolean;
  onSubmit?: () => void;
  disableSubmit?: boolean;
  rightContent?: ReactElement;
}): ReactElement {
  const isMobile = useIsMobile();
  const classes = useStyles({ isMobile });
  const intl = useIntl();
  return (
    <div className={cn(classes.submitFooter, classes.castShadow)}>
      <Divider className={cn(classes.fullWidth)} />
      <div className={classes.footerPadding}>
        <Button onClick={onCancel} disabled={isPosting}>
          {formatTranslation(intl, CommonTranslationKeys.cancel)}
        </Button>
        <div className={classes.rightContent}>
          {rightContent || (
            <MemoButtonContained
              onClick={onSubmit}
              endIcon={
                isPosting ? <CircularProgress size={16} /> : undefined
              }
              disabled={isPosting || disableSubmit}
            >
              {formatTranslation(intl, CommonTranslationKeys.save)}
            </MemoButtonContained>
          )}
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles<Theme, { isMobile: boolean }>((theme) =>
  createStyles({
    fullWidth: {
      width: '100%',
    },
    castShadow: {
      boxShadow: '0px -4px 4px -2px rgba(0, 0, 0, 0.15)',
    },
    submitButtons: {
      display: 'flex',
      flexDirection: 'row',
      columnGap: '16px',
    },
    submitButtonSpacing: { marginRight: '19px' },
    rightContent: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: '16px',
    },
    // @ts-ignore
    submitFooter: {
      position: 'fixed',
      bottom: '0',
      backgroundColor: '#FFF',
      zIndex: 1,
      left: 0,
      right: 0,
      '& > div': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
      [theme.breakpoints.up('sm')]: {
        left: '64px',
      },
    },
    footerPadding: {
      paddingTop: '11px',
      paddingBottom: '12px',
      paddingRight: '29px',
      paddingLeft: '16px',
    },
  })
);
